import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { clinicQKeys } from "@hooks/queries/clinic/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteClinicTreatmentPlan = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (treatmentPlanId: string) => {
      return api.delete(`clinic/treatment-services/${treatmentPlanId}`);
    },
    onSuccess: () => {
      showSuccessNotification({
        title: "success",
        message: "delete-treatment-plan-success",
      });
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.treatmentPlans(),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Clinic Treatment Plan]", res);
      queryClient.invalidateQueries({
        queryKey: clinicQKeys.treatmentPlans(),
      });

      handleErrors(res, "mutation");
    },
  });
};
